export var WorkorderStatus;
(function (WorkorderStatus) {
    WorkorderStatus[WorkorderStatus["Nieuw"] = 1] = "Nieuw";
    WorkorderStatus[WorkorderStatus["Geoffreerd"] = 2] = "Geoffreerd";
    WorkorderStatus[WorkorderStatus["Opdracht_door_klant"] = 3] = "Opdracht_door_klant";
    WorkorderStatus[WorkorderStatus["Monteur_Uit_te_voeren"] = 4] = "Monteur_Uit_te_voeren";
    WorkorderStatus[WorkorderStatus["Wachten_op_klant"] = 5] = "Wachten_op_klant";
    WorkorderStatus[WorkorderStatus["Monteur_Onder_handen"] = 6] = "Monteur_Onder_handen";
    WorkorderStatus[WorkorderStatus["Technisch_gereed"] = 7] = "Technisch_gereed";
    WorkorderStatus[WorkorderStatus["Gefactureerd"] = 8] = "Gefactureerd";
    WorkorderStatus[WorkorderStatus["Vervallen"] = 9] = "Vervallen";
    WorkorderStatus[WorkorderStatus["Garantie"] = 10] = "Garantie";
    WorkorderStatus[WorkorderStatus["Delen_in_bestelling"] = 11] = "Delen_in_bestelling";
    WorkorderStatus[WorkorderStatus["Monteur_Diagnose_stellen"] = 12] = "Monteur_Diagnose_stellen";
    WorkorderStatus[WorkorderStatus["Bestellingen_zijn_binnen"] = 13] = "Bestellingen_zijn_binnen";
    WorkorderStatus[WorkorderStatus["Beoordelen__calculeren"] = 14] = "Beoordelen__calculeren";
    WorkorderStatus[WorkorderStatus["Nagecalculeerd"] = 15] = "Nagecalculeerd";
    WorkorderStatus[WorkorderStatus["Monteur_Werk_uitgevoerd"] = 16] = "Monteur_Werk_uitgevoerd";
    WorkorderStatus[WorkorderStatus["Offerte_opgevraagd"] = 17] = "Offerte_opgevraagd";
    WorkorderStatus[WorkorderStatus["Vijftig_procent_aanbetaling_verstuurd"] = 18] = "Vijftig_procent_aanbetaling_verstuurd";
    WorkorderStatus[WorkorderStatus["Deellevering"] = 19] = "Deellevering";
    WorkorderStatus[WorkorderStatus["Tweede_meting_inplannen"] = 20] = "Tweede_meting_inplannen";
})(WorkorderStatus || (WorkorderStatus = {}));
// Factuur_verzendklaar = 17 deleted
